import { inject } from "vue"

export const useReport = () => {
  const httpService = inject("$baseHttpClient") as any

  const getReports = async (): Promise<any> => {
    try {
      const response = await httpService.get(`/Report/Menu`)
      if (response.status === 200) {
        return response.data
      }
      return null
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  return {
    getReports,
  }
}
